import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useWizard } from '../../hooks/useWizard';
import WizardProgress from '../../components/WizardProgress';
import Step1 from '../../components/Steps/Step1';
import Step2 from '../../components/Steps/Step2';
import { ROUTES } from '../../../../core/constants/routes';
import './styles.css';

const WizardPage = () => {
  const navigate = useNavigate();
  const {
    currentStep,
    selectedActivity,
    onActivitySelect,
    nextStep,
    prevStep
  } = useWizard();

  const handleNext = () => {
    if (currentStep === 1) {
      nextStep();
    } else if (currentStep === 2) {
      navigate(ROUTES.DASHBOARD, { 
        state: { 
          openCreatePost: true,
          initialTitle: selectedActivity,
          description: selectedActivity
        } 
      });
    }
  };

  const handleBack = () => {
    if (currentStep === 2) {
      prevStep();
    }
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <Step1 onNext={handleNext} />;
      case 2:
        return (
          <Step2
            onNext={handleNext}
            onPrev={handleBack}
            selectedActivity={selectedActivity}
            onActivitySelect={onActivitySelect}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="wizard-container">
      <WizardProgress currentStep={currentStep} />
      {renderStep()}
    </div>
  );
};

export default WizardPage; 